import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Record } from '@common/data-models/records/record';
import { CustomFieldsSerializer } from '@common/data-models/serializers/serializers';
import { ServiceResponse } from '@common/data-models/service/service-response';

import { AsyncServiceBase } from './async-service-base';
import { GlobalTablesService } from './global-tables-service';
import { NomWebServicesJson } from './nom-web-services-json';

@Injectable({ providedIn: 'root' })
export class CustomCardFieldsService extends AsyncServiceBase {
    public CustomCardFields: Array<FieldDef> = null;

    constructor(
        public nomWebServicesJson: NomWebServicesJson,
        public globalTablesService: GlobalTablesService
    ) {
        super();

        Record.customCardFieldsService = this;

        this.globalTablesService.globalTablesLoaded.subscribe(() => {
            this.getCustomCardFieldsAndResolve();
        });
    }

    public async getCustomCardFieldsAndResolve(): Promise<any> {
        this.initializeCustomCardFields();
        this.initializeResolve(null);
    }

    public initializeCustomCardFields(fields?: any) {
        if (!fields) {
            fields = localStorage.getItem('CustomCardFields');
            fields = JSON.parse(fields);
        }
        this.CustomCardFields = CustomFieldsSerializer.Instance(this.globalTablesService).initialize(fields);

        this.nomWebServicesJson.CustomCardFields = fields;
        this.nomWebServicesJson.saveCustomCardFieldsSessionData();
    }

    public async updateTeamCustomCardFields(fields: Array<FieldDef>, team: string): Promise<ServiceResponse<boolean>> {
        const fieldsSerialized = CustomFieldsSerializer.Instance(this.globalTablesService).serialize(fields);

        let response: HttpResponse<any> = null;
        try {
            response = await this.nomWebServicesJson.put(
                '/api/PSTCustomCardFields',
                {
                    CustomCardFields: JSON.parse(fieldsSerialized),
                    Team: team,
                },
                {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                        'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                    }),
                    responseType: 'json',
                    observe: 'response',
                }
            );
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Failed to update PST custom card fields!',
                detailMessage: `Failed to update PST custom card fields! \n\rStackTrace: CustomCardFieldsService.updateCustomCardFields(); \n\rError: ${error}`,
            });
            return new ServiceResponse<boolean>(false, false);
        }
        if (response.status) {
            this.CustomCardFields = fields;
            this.nomWebServicesJson.CustomCardFields = fields.filter(item => !!item).map(item => item.ID);
            this.nomWebServicesJson.saveCustomCardFieldsSessionData();
        }
        return new ServiceResponse<boolean>(true, response.body);
    }

    public async loadTeamCustomCardFields(team: string) {
        const result = await this.getTeamCustomCardFields(team);
        if (result.status) {
            let fields = CustomFieldsSerializer.Instance(this.globalTablesService).initialize(result.data);
            fields = fields.filter(item => !!item);
            this.CustomCardFields = fields;
            this.nomWebServicesJson.CustomCardFields = fields.map(item => item.ID);
            this.nomWebServicesJson.saveCustomCardFieldsSessionData();
        }
    }

    public async getTeamCustomCardFields(team: string): Promise<ServiceResponse<any>> {
        let response: HttpResponse<any> = null;

        response = await this.nomWebServicesJson.get('/api/PSTCustomCardFields', {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
            }),
            responseType: 'json',
            params: {
                team,
            },
            observe: 'response',
        });
        return new ServiceResponse<any>(true, response.body);
    }
}
